<template>
    <div class="home-page">
		<Header></Header>
		<div class="">
			<div class="nav">
				<span class="">{{$t('Ranking')}}</span>
			</div>
			<div class="ranking-list">
				<div class="tab">
					<div class="tab-li" :class="{'active':isType=='week'}" @click="tabDay('week')">{{$t('Weekly')}}</div>
					<div class="tab-li" :class="{'active':isType=='month'}" @click="tabDay('month')">{{$t('Monthly')}}</div>
					<div class="tab-li" :class="{'active':isType=='year'}" @click="tabDay('year')">{{$t('Yearly')}}</div>
				</div>
        <div class="section-content">
        	<div class="font-c flex-between flex" :class="{'bgyl':index<3}" v-for="(item,index) in list">
        		<div class="num num2 fs33" v-if="index+1==1"><img src="../../static/images/no1.png"></div>
        		<div class="num num2 fs33" v-if="index+1==2"><img src="../../static/images/no2.png"></div>
        		<div class="num num2 fs33" v-if="index+1==3"><img src="../../static/images/no3.png"></div>
        		<div class="num fs33" v-if="index+1!=1&&index+1!=2&&index+1!=3">{{index+1}}</div>
            <img style="width: 90px;height: 90px" class="at1" :src="item.avatar">
        		<p class="fw7">{{item.phone}}</p>
        		<div class="total_score fs26">
        			<img src="../../static/images/xing.png">{{item.total_score}}
        		</div>
        	</div>
        </div>
				<!-- <Loadmore :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore" :isLoadMore="isLoadMore">
					 <div slot="loadMore" >

					</div>
				</Loadmore> -->
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import Loadmore from '../components/LoadMore'
export default {
    components:{
		Header,
		Loadmore
    },
    data() {
      return {
        notFound:false,
        list:[],
        page:1,
        enableLoadMore: true,
        isLoadMore:true,
        isType:'week',
      }
    },
    mounted() {
		let that = this;
    },
	created(){
		this.getHome('week')
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		tabDay(type){
			this.page = 1
			this.isType = type;
			this.enableLoadMore = true
			this.isLoading = true
			this.getHome(type);
		},
		onLoadMore(done) {
      setTimeout(()=>{
        if(!this.enableLoadMore) {
          this.$utils.alertText(this.$t('no_data'),80);
        }
        this.page = this.page + 1
        this.getHome();
        done();
      }, 200)
    },
		getHome(type){
			let that =this;
			//that.$parent.loadModal(true);
			// let url = '/rank/month&page_id='+that.page+'&page_size=10'
      let data = {
        type:type
      }

      that.$parent.loadModal(true);
			let url = 'api/index/game_score_rank'
			that.$api.post(url,data,r =>{
				that.$parent.returnCode(r,function(){
          that.list = r.data
					that.$parent.loadModal(false);
          return;
					if(that.page==1){
						if(r.data.length<10){
							that.isLoadMore = false;
						}
						that.list = r.data
					}else{
						that.isLoadMore = true;
						if(r.data.length == 0) {
							that.enableLoadMore = false
						}
						that.list = that.list.concat(r.data)
					}
       });

			})
		}
	}
}
</script>
<style>
  .at1{border: 4px solid #fdf790;border-radius: 100%;}
  .ranking-list .section-content{height: calc(100vh - 480px); overflow-y: scroll;}
  .section-content{margin: 0 30px;}
  .section-content .font-c{background: linear-gradient(to top, #0050fe, #74f0ff);border-radius: 20px;padding:20px;margin-top: 20px;}
  .section-content .bgyl{background: linear-gradient(to top, #f69008, #ffdf31);}
  .section-content .font-c p{font-size: 30px;text-shadow: 3px 3px 0 #001d8c;}
  .total_score{background: #0032a6;border:3px solid #fff;color: #fff;display: block;padding: 10px 0;border-radius: 40px;min-width: 200px;text-align: center;}
  .num{min-width: 100px;text-align: center;text-shadow: 4px 4px 0 #001d8c;font-size: 40px;}
</style>



// WEBPACK FOOTER //
// src/page/ranking.vue